import {Router} from "@/rawdogjs/src/router";
import {ApiClientBase} from "./WebApiClientBase";
import {ParcelWebHttpClient} from "./ParcelWebHttpClient";
import {AuthenticationManager} from "./AuthenticationManager";

export class BearerTokenApi extends ApiClientBase {


    constructor(
        router: Router,
        httpClient: ParcelWebHttpClient,
        authenticationManager: AuthenticationManager,
        url:string = null
    ) {
        super(
            '/api/tokens', 
            router, 
            httpClient,
            authenticationManager,
            url
        );
    }

}